<div [formGroup]="formParent" fxLayoutGap="32px">
    <mat-form-field class="w-100">
        <mat-label>{{ 'FARM.COUNTRY.COUNTRY' | translate }}</mat-label>
        <mat-select formControlName="country">
            <mat-option ngDefaultControl *ngFor="let country of countries" [value]="country.cod">{{ 'FARM.COUNTRY.' + country.country | uppercase | translate }}</mat-option>
        </mat-select>
    </mat-form-field>
    <div *ngIf="formParent.controls['country'].value=='es'" >
        <mat-form-field class="w-100">
            <mat-label>{{ 'FARM.PROVINCE' | translate }}</mat-label>
            <mat-select  formControlName="province" (selectionChange)="onChangeProvince($event)" required>
              <mat-option *ngFor="let province of provinces"  [value]="province.idProvince">{{province.provinceName}} </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100">
              <mat-label>{{ 'FARM.TOWN_HALL' | translate }}</mat-label>
              <mat-select  formControlName="townHall" (selectionChange)="selectedTownHall($event.value)" required>
                <mat-option *ngFor="let th of townHalls"  [value]="th.idTownHall" >{{th.townHallName}} </mat-option>
              </mat-select>
        </mat-form-field>
    </div>    
    <div *ngIf="formParent.controls['country'].value=='pt'" >
        <mat-form-field class="w-100">
            <mat-label>{{ 'FARM.DISTRICT' | translate }}</mat-label>
            <mat-select  formControlName="district" (selectionChange)="onChangeDistrict($event)" required>
                <mat-option *ngFor="let district of districts"  [value]="district.idDistrict">{{district.districtName}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>{{ 'FARM.MUNICIPALITY' | translate }}</mat-label>
            <mat-select formControlName="municipality" (selectionChange)="onSelectedMunicipality($event.value)" required>
                <mat-option *ngFor="let munic of municipalities"  [value]="munic.idMunicipality">{{munic.municipalityName}}  </mat-option>
            </mat-select>
        </mat-form-field>
    </div> 
    <mat-form-field class="w-100 mb-3">
        <mat-label>{{ 'FARM.AREA' | translate }}{{ 'FARM.IN_HECTARES' | translate }}({{ 'SYSTEM.COMMA' | translate }})</mat-label>
        <input matInput type="number"  placeholder="{{'FARM.AREA' | translate}} en hectáreas" formControlName="area" required>
    </mat-form-field>
    <div fxLayout="row wrap" fxLayoutGap="32px"  fxLayoutAlign="flex-start">
        <label>{{ 'FARM.DESITE_TO.DESITE_TO' | translate }}:</label>
        <ng-container *ngFor="let exp of data_exploitation">
            <mat-checkbox class=" ml-1" [checked]="checkExploitations(exp)"  (change)="onChange($event,'exploitations',exp)">{{'FARM.DESITE_TO.TYPE.' + exp.type | uppercase | translate }}</mat-checkbox>
        </ng-container>
    </div>

    <div class="mt-3" fxLayout="row wrap" fxLayoutGap="32px" fxLayoutAlign="flex-start">
        <label>{{ 'FARM.OBJECTIVES_TO.OBJECTIVES_TO' | translate }}:</label>

        <ng-container *ngFor="let obj of data_objectives">
            <mat-checkbox class="ml-1" [checked]="checkObjectives(obj)" (change)="onChange($event, 'objectives', obj)">{{ 'FARM.OBJECTIVES_TO.TYPE.' + obj.type | uppercase | translate }}</mat-checkbox>  
        </ng-container>
    </div>

    <div class="mt-3" fxLayout="row wrap" fxLayoutGap="32px" fxLayoutAlign="flex-start">
        <mat-label id="radio-group-label-access">{{ 'FARM.ACCESS_ROAD.ACCESS_ROAD' | translate }}</mat-label>
        <mat-radio-group formControlName="access" aria-labelledby="radio-group-label-access" required>
            <mat-radio-button class="mr-2" [value]=true >{{ 'FARM.ACCESS_ROAD.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]=false>{{ 'FARM.ACCESS_ROAD.NO' | translate }}</mat-radio-button>    
        </mat-radio-group>    
    </div>

    <div class="center" *ngIf="!isEdit">
        <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="droppedImages($event)"
        (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <button mat-raised-button class="ml-3" type="button" (click)="openFileSelector()">{{ 'FARM.UPLOAD_IMAGES' | translate }}</button>
            </ng-template>
        </ngx-file-drop>
        <div class="upload-table">
            <table class="table" *ngIf="imagesAccepted.length>0">
                <thead>
                    <tr>
                        <th>{{ 'FARM.NAME_FILE' | translate }}</th>
                        <th>{{ 'FARM.ACTION' | translate }}</th>
                    </tr>
                </thead>
                <tbody class="upload-name-style">
                    <tr *ngFor="let item of imagesAccepted; let i=index">
                        <td><strong>{{ item.name }}</strong></td>
                        <td>
                          <button color="warn" mat-icon-button (click)="onDeleteImage(i)">
                          <mat-icon>remove</mat-icon>
                      </button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <span *ngIf="filesAmount > 0"> {{filesAmount}} {{ 'FARM.SELECT_IMAGES' | translate }} </span>
    <mat-form-field class="w-100 mt-3">
        <mat-label>{{ 'FARM.INFO_FARM' | translate }}</mat-label>
        <textarea maxlength=1024 matInput type="text" rows="4" placeholder="{{'FARM.INFO' | translate}}"  formControlName="information" required></textarea>
    </mat-form-field>  
</div>